import PlusIcon from "@assets/icons/plus.svg";

import { cn } from "@utils/tailwind.util";
import { View } from "@ui/View";

interface Props {
  title: string;
  searchQuery: string;
  action: VoidFunction;
}

export function NewEntityOptionItem({ title, searchQuery, action }: Props) {
  return (
    <li
      role="option"
      aria-setsize={2}
      className={cn(
        "inline-flex items-center gap-2 flex-none h-7 w-full max-w-full cursor-pointer",
        "hover:bg-background-secondary dark:hover:bg-gray-700 rounded-md p-1 pr-2 align-middle leading-none"
      )}
      tabIndex={-1}
      onClick={action}
      onMouseDown={(e) => e.preventDefault()} // Stop native scrolling
    >
      <PlusIcon width={20} height={20} className="flex-shrink-0 dark:text-white" />
      <div className="max-w-[215px] flex gap-1 text-sm font-medium text-gray-950 dark:text-white">
        <span>New</span>
        <View.Condition if={!!searchQuery}>
          <span className="grid grid-flow-col">
            <span>"</span>
            <span className="text-overflow-ellipsis inline-block max-w-[150px] align-bottom">
              {searchQuery}
            </span>
            <span>"</span>
          </span>
        </View.Condition>
        <span>{title}</span>
      </div>
    </li>
  );
}
